import { render, staticRenderFns } from "./PeopleTourDetail.vue?vue&type=template&id=2e97c67b"
import script from "./PeopleTourDetail.vue?vue&type=script&setup=true&lang=js"
export * from "./PeopleTourDetail.vue?vue&type=script&setup=true&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports